import { BaitTypes, BaitViewTypes } from "../js/constants/BaitTypes";
import basic from "./basic";

import team1Src from "../assets/images/teams/parizhane.svg";
import team2Src from "../assets/images/teams/zmei.svg";
import team3Src from "../assets/images/teams/blaugrana.svg";
import team4Src from "../assets/images/teams/fk-gollivud.svg";
import team5Src from "../assets/images/teams/shmeli.svg";
import team6Src from "../assets/images/teams/trenerishka-team.svg";
import team7Src from "../assets/images/teams/kanoniri.svg";
import team8Src from "../assets/images/teams/galaktikos.svg";
import { snakeImages } from "./resources/images";

const images = [...snakeImages];

const teamImages = {
    parizhane: team1Src,
    zmei: team2Src,
    blaugrana: team3Src,
    "fk-gollivud": team4Src,
    shmeli: team5Src,
    "trenerishka-team": team6Src,
    kanoniri: team7Src,
    galaktikos: team8Src,
};

const selectTeamTitle = "Выбери команду, за которую будешь играть";
const selectTeamNext = "Старт";

const baits = Object.entries(BaitViewTypes).map(([key, value]) => {
    return {
        id: value,
        viewType: value,
    };
});

const getTeamDeathBaits = (teamId) =>
    baits.filter(
        (bait) => {
            return bait.id !== teamId && bait.id !== BaitViewTypes.BALL
        }
    );

const game = {
    aims: {
        selectTitle: "Выбери и&nbsp;кликни на&nbsp;команду, за&nbsp;которую будешь играть",
        selectTitleShort: "Выбери команду, за&nbsp;которую будешь играть",
        nextLabel: "Выбрать",
        optionType: "radio",
        options: basic.teams.map((team) => {
            return {
                id: team.id,
                label: team.name,
                image: teamImages[team.id],
                selectTitle: selectTeamTitle,
                nextLabel: selectTeamNext,
                optionType: "radio",
                viewType: BaitViewTypes.BALL,
                deathBaits: getTeamDeathBaits(team.id),
            };
        }),
    },
    restartFromTheVeryBeginning: false,
    gameplay: {
        sizes: {
            w: 15,
            h: 11,
            portrait: {
                w: 11,
                h: 12,
            },
        },
        numLifes: 3,
        snake: {
            head: 1,
            tail: 1,
            bodyStart: 0,
            minSpeed: 0.5,
            maxSpeed: 8,
        },
        addItems: {
            numPerTime: 5,
            baitItemsProportion: "10:0:1",
            settings: {
                [BaitTypes.AIM]: {
                    lifeTime: -1,
                    action: {
                        points: 1,
                        life: 0,
                        speedIncrement: 0.02,
                        bonusIncrement: 1,
                    },
                },
                [BaitTypes.UNSELECTED]: {
                    lifeTime: 4,
                    action: {
                        points: -1,
                        life: 0,
                        speedIncrement: -0.5,
                    },
                },
                [BaitTypes.DEATH]: {
                    lifeTime: -1,
                    action: {
                        points: 0,
                        life: -1,
                        speedIncrement: -1000,
                    },
                },
            },
        },
        selfEating: {
            action: {
                points: 0,
                life: -10,
                speedIncrement: -1000,
            },
        },
        displayNextItems: false,
        maxDuration: 60,
    },
    images,
};

export default game;
